import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container-fluid mt-2" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = { class: "list-group" }
const _hoisted_5 = {
  key: 0,
  class: "list-group-item"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-download" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("b", null, "Name:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          (_ctx.logs.length < 1)
            ? (_openBlock(), _createElementBlock("li", _hoisted_5, "Nothing here yet"))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.logs, (log) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "list-group-item",
                  "aria-current": "false",
                  key: log.generation
                }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-light",
                    onClick: ($event: any) => (_ctx.downloadLogFile(log.fullPath))
                  }, _hoisted_8, 8, _hoisted_6),
                  _hoisted_9,
                  _createTextVNode(" " + _toDisplayString(log.name) + " (" + _toDisplayString(log.updated) + ") ", 1)
                ]))
              }), 128))
        ])
      ])
    ])
  ]))
}